import React from "react";

const Card = ({ children, className, type }) => {
  return (
    <div
      className={`border p-2 border-slate-300 bg-slate-100 rounded-md ${type === "empty-state" && "w-full text-center text-slate-400 italic"} ${className}`}
    >
      {children}
    </div>
  );
};

export default Card;
